import React from 'react';
import { Typography, IconButton, Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import MailIcon from '../assets/mailIcon.jpg';
import LinkedInIcon from '../assets/linkedIn.png';
import LeetCodeIcon from '../assets/leetCode.png';
import GitHubIcon from '../assets/github.png';
import InstagramIcon from '../assets/instagram.png';
import SmileyIcon from '../assets/smiley.png';

function Contact() {
  const currentRoute = useLocation().pathname;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <IconButton
          onClick={() => window.location.href = 'mailto:nisant.chilakamarri@gmail.com'}
          sx={{ margin: '6px' }}
          aria-label="Send an email"
        >
          <img src={MailIcon} alt="Mail" height="18" width="18" />
        </IconButton>
        <IconButton
          component="a"
          href="https://www.linkedin.com/in/nisanthchsr/"
          target="_blank"
          sx={{ margin: '6px' }}
          aria-label="LinkedIn"
        >
          <img src={LinkedInIcon} alt="LinkedIn" height="18" width="18" />
        </IconButton>
        <IconButton
          component="a"
          href="https://leetcode.com/nisanth_chsr/"
          target="_blank"
          sx={{ margin: '6px' }}
          aria-label="LeetCode"
        >
          <img src={LeetCodeIcon} alt="LeetCode" height="18" width="18" />
        </IconButton>
        <IconButton
          component="a"
          href="https://github.com/NisanthChsr/"
          target="_blank"
          sx={{ margin: '6px' }}
          aria-label="GitHub"
        >
          <img src={GitHubIcon} alt="GitHub" height="18" width="18" />
        </IconButton>
        <IconButton
          component="a"
          href="https://www.instagram.com/_nisanth_chsr_/"
          target="_blank"
          sx={{ margin: '6px' }}
          aria-label="Instagram"
        >
          <img src={InstagramIcon} alt="Instagram" height="18" width="18" />
        </IconButton>
      </Box>

      {currentRoute === '/' && (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Typography sx={{ marginRight: '2px' }}>
            Feedback is appreciated
          </Typography>
          <img src={SmileyIcon} alt="Smiley" style={{ margin: '6px' }} height="15" width="15" />
        </Box>
      )}
    </Box>
  );
}

export default Contact;
